import { render, staticRenderFns } from "./FCSwiper.vue?vue&type=template&id=15664bed&scoped=true&"
import script from "./FCSwiper.vue?vue&type=script&lang=ts&"
export * from "./FCSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./FCSwiper.vue?vue&type=style&index=0&id=15664bed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15664bed",
  null
  
)

export default component.exports